var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerprintId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.18,
    height: 17.6,
    viewBox: "0 0 20.18 17.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-id"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.2,2.2c.3.1.7.1,1,.2a6.22,6.22,0,0,1,3.5,2.2s-.4.5-.6.7A5.56,5.56,0,0,0,6.2,3.9c-.1-.2-.2-.3-.3-.5s-.1-.2-.2-.4a7.6,7.6,0,0,1,1.1-.4l1.4-.3h.1A2.77,2.77,0,0,1,9.2,2.2Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3,11.5v-1H3.5A1.28,1.28,0,0,0,4.6,9.3V8.1A4.28,4.28,0,0,1,7.8,4.6a4.17,4.17,0,0,1,5.1,3.5V9.2c0,.3-.2.9-.5,1s-.4.1-.5-.3a2,2,0,0,0,.1-.8,3.89,3.89,0,0,0-.2-1.5A3.06,3.06,0,0,0,8.5,5.5,3.4,3.4,0,0,0,5.6,8.2a4.05,4.05,0,0,0,0,1.1,2.06,2.06,0,0,1-1.8,2.1A7.08,7.08,0,0,1,2.3,11.5Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12.6h1a3.93,3.93,0,0,1-1.5,3.2,4.08,4.08,0,0,1-4.6.4,4.16,4.16,0,0,1-2.2-3.6h1A3.31,3.31,0,0,0,9,15.8,3.19,3.19,0,0,0,12,12.6Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6,10.1h-1V8.6a.79.79,0,0,0-.8-.8,1,1,0,0,0-.9.7v1.7h-1V8.4a2,2,0,0,1,2-1.5,1.84,1.84,0,0,1,1.7,1.8Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9,11.2h1v1.4a.9.9,0,1,0,1.8,0V11.2h1v1.7a1.8,1.8,0,0,1-2,1.5A1.84,1.84,0,0,1,7,12.6,6.15,6.15,0,0,1,6.9,11.2Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,3.6c.2.3.4.5.6.8A6.2,6.2,0,0,0,3.7,6.6a7.46,7.46,0,0,0-.4,2.6h-1a6.34,6.34,0,0,1,.5-3A6.3,6.3,0,0,1,4.8,3.6Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,16.7c.3-.2.5-.4.8-.6a5.52,5.52,0,0,0,4.1,2.1,3.75,3.75,0,0,0,.1,1,7.8,7.8,0,0,1-2.2-.4A8.26,8.26,0,0,1,3.7,16.7Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3,12.6h1A4.84,4.84,0,0,0,4,15.2c-.3.2-.6.3-.9.5A6.21,6.21,0,0,1,2.3,12.6Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5.6c0,.05,0,.1,0,.15a8.81,8.81,0,0,1,.33,1c-.34.09-.6.18-.87.27-.1-.3-.3-.7-.4-1C13.9,5.9,14.2,5.7,14.5,5.6Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_109",
    "data-name": "Capa 109"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7,12.7a4.1,4.1,0,1,1,3.1,4.9A4.16,4.16,0,0,1,13.7,12.7Zm.6.1a3.49,3.49,0,1,0,4.2-2.6A3.48,3.48,0,0,0,14.3,12.8Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.8c-.1-.1,0-.3.1-.4s.3,0,.4.1l.6,1c.1.1-.3.5-.3.4A7.63,7.63,0,0,1,20,17.8Z",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.97 -1.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintId);
export default __webpack_public_path__ + "static/media/fingerprint-id.bdc2e1def123e88a1fb534731e08005a.svg";
export { ForwardRef as ReactComponent };